// extracted by mini-css-extract-plugin
export default {"import":"import_import__KOfEw","button":"import_button__sePOS","icon":"import_icon__zcAy9","text":"import_text__EP1DJ"};